import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import "./Header.css";

export default function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const [aboutOpen, setAboutOpen] = useState(false);
  const [commitmentOpen, setCommitmentOpen] = useState(false);
  const [qualityOpen, setQualityOpen] = useState(false);
  const [b2bOpen, setB2bOpen] = useState(false);

  const location = useLocation();

  /* ===============================
     STICKY HEADER
  ============================== */
useEffect(() => {
  const handleScroll = () => {
    setIsSticky(window.scrollY > 80);  // scroll after 80px
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  /* ===============================
     CLOSE SUBMENUS WHEN MENU CLOSES
  ============================== */
  useEffect(() => {
    if (!expanded) {
      setAboutOpen(false);
      setCommitmentOpen(false);
      setQualityOpen(false);
      setB2bOpen(false);
    }
  }, [expanded]);

  /* ===============================
     ROUTE DETECTION
  ============================== */

  const aboutRoutes = [
    "/batterjee-group",
    "/team",
    "/history",
    "/commitment",
    "/vademecum",
  ];

  const commitmentRoutes = [
    "/commitment",
    "/commitment/with-the-people",
    "/commitment/ethics",
    "/commitment/environmental",
    "/commitment/sustainable-development",
  ];

  const qualityRoutes = [
    "/quality",
    "/quality/production-plants",
    "/quality/quality-systems",
    "/quality/certifications",
  ];
  const b2bRoutes = [
  "/b2b/comprehensive-solutions",
  "/b2b/team",
  "/b2b/quality",
  "/b2b/pipeline",
  "/b2b/manufacturing-plants",
];

  const isAboutActive = aboutRoutes.some(path =>
    location.pathname.startsWith(path)
  );

  const isCommitmentActive = commitmentRoutes.some(path =>
    location.pathname.startsWith(path)
  );

  const isQualityActive = qualityRoutes.some(path =>
    location.pathname.startsWith(path)
  );
  const isB2bActive = b2bRoutes.some(path =>
  location.pathname.startsWith(path)
);

  /* ===============================
     AUTO OPEN ACTIVE MENUS (MOBILE)
  ============================== */

  useEffect(() => {
    if (expanded && isAboutActive) setAboutOpen(true);
  }, [expanded, isAboutActive]);

  useEffect(() => {
    if (expanded && isCommitmentActive) {
      setAboutOpen(true);
      setCommitmentOpen(true);
    }
  }, [expanded, isCommitmentActive]);

  useEffect(() => {
    if (expanded && isQualityActive) {
      setQualityOpen(true);
    }
  }, [expanded, isQualityActive]);

  useEffect(() => {
  if (expanded && isB2bActive) {
    setB2bOpen(true);
  }
}, [expanded, isB2bActive]);

  return (
    <>
      {/* TOP BAR */}
      <div className={`top-bar ${isSticky ? "hide-topbar" : ""}`}>
        <Container className="d-flex justify-content-end align-items-center">
          <span>PHARMACOVIGILANCE</span>
          <span>CONTACT</span>
          <span>BATTERJEE SPAIN</span>
        </Container>
      </div>

      {/* HEADER */}
      <header className={`main-header ${isSticky ? "menu-sticky" : ""}`}>
        <Navbar
          expand="lg"
          className="main-navbar"
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
        >
          <Container>

            {/* LOGO */}
            <Navbar.Brand
              as={NavLink}
              to="/"
              className="logo"
              onClick={() => setExpanded(false)}
            >
              <img src={logo} alt="Batterjee Pharma" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="main-navbar-nav" />

            <Navbar.Collapse id="main-navbar-nav">
              <Nav className="mx-auto main-menu">

                {/* ================= ABOUT US ================= */}
                <div
                  className={`nav-item dropdown-hover
                    ${aboutOpen ? "open" : ""}
                    ${isAboutActive ? "active" : ""}
                  `}
                >
                  <span
                    className="nav-link"
                    onClick={() => setAboutOpen(!aboutOpen)}
                  >
                    ABOUT US <span className="caret">▾</span>
                  </span>

                  <div className="dropdown-menu-custom">
                    <NavLink to="/batterjee-group">Batterjee Group</NavLink>
                    <NavLink to="/team">Team</NavLink>
                    <NavLink to="/history">History</NavLink>

                    {/* ================= COMMITMENT ================= */}
                    <div
                      className={`nav-item nested
                        ${commitmentOpen ? "open" : ""}
                        ${isCommitmentActive ? "active" : ""}
                      `}
                    >
                      <a
                        href="#!"
                        className="submenu-link"
                        onClick={(e) => {
                          e.preventDefault();
                          if (window.innerWidth <= 992) {
                            setCommitmentOpen(!commitmentOpen);
                          }
                        }}
                      >
                        Commitment <span className="caret">▸</span>
                      </a>

                      <div className="dropdown-menu-custom nested-menu">
                        <NavLink
                          to="/commitment/with-the-people"
                          onClick={() => setExpanded(false)}
                        >
                          With the People
                        </NavLink>

                        <NavLink
                          to="/commitment/ethics"
                          onClick={() => setExpanded(false)}
                        >
                          Ethics and transparency
                        </NavLink>

                        <NavLink
                          to="/commitment/environmental"
                          onClick={() => setExpanded(false)}
                        >
                          Environmental
                        </NavLink>

                        <NavLink
                          to="/commitment/sustainable-development"
                          onClick={() => setExpanded(false)}
                        >
                          Sustainable economic development
                        </NavLink>
                      </div>
                    </div>

                    <NavLink to="/vademecum">Vademecum</NavLink>
                  </div>
                </div>

                {/* ================= QUALITY ================= */}
                <div
                  className={`nav-item dropdown-hover
                    ${qualityOpen ? "open" : ""}
                    ${isQualityActive ? "active" : ""}
                  `}
                >
                  <span
                    className="nav-link"
                    onClick={() => setQualityOpen(!qualityOpen)}
                  >
                    QUALITY <span className="caret">▾</span>
                  </span>

                  <div className="dropdown-menu-custom">
                    <NavLink
                      to="/quality/quality"
                      onClick={() => setExpanded(false)}
                    >
                      Quality
                    </NavLink>
                    <NavLink
                      to="/quality/production-plants"
                      onClick={() => setExpanded(false)}
                    >
                      Production plants
                    </NavLink>

                    

                  </div>
                </div>

                {/* PRODUCTS */}
                <NavLink
                  to="/products"
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                >
                  PRODUCTS
                </NavLink>

             {/* ================= B2B PARTNERING ================= */}
<div
  className={`nav-item dropdown-hover
    ${b2bOpen ? "open" : ""}
    ${isB2bActive ? "active" : ""}
  `}
>
  <span
    className="nav-link"
    onClick={() => setB2bOpen(!b2bOpen)}
  >
    B2B PARTNERING <span className="caret">▾</span>
  </span>

  <div className="dropdown-menu-custom">
    <NavLink
      to="/b2b/comprehensive-solutions"
      onClick={() => setExpanded(false)}
    >
      Comprehensive Solutions
    </NavLink>

    <NavLink
      to="/b2b/team"
      onClick={() => setExpanded(false)}
    >
      Team
    </NavLink>

    <NavLink
      to="/quality/quality"
      onClick={() => setExpanded(false)}
    >
      Quality
    </NavLink>

    <NavLink
      to="/b2b/pipeline"
      onClick={() => setExpanded(false)}
    >
      Pipeline
    </NavLink>

    <NavLink
      to="/b2b/manufacturing-plants"
      onClick={() => setExpanded(false)}
    >
      Manufacturing plants
    </NavLink>
  </div>
</div>

                {/* NEWS */}
                <NavLink
                  to="/news"
                  className="nav-link"
                  onClick={() => setExpanded(false)}
                >
                  NEWS & HEALTH
                </NavLink>

              </Nav>

              {/* LANGUAGE */}
              <div className="lang-inline">
                <NavLink to="/en" className="lang active">EN</NavLink>
                <NavLink to="/sa" className="lang">SA</NavLink>
              </div>

            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

      {isSticky && <div style={{ height: "120px" }} />}
    </>
  );
}